import React, { useContext, useEffect, useState } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { FilterValue } from '../Action/Action';
import { GVarState } from '../StoreState/Gstate';

function    StartAndEndSearch() {
    let g = useContext(GVarState);
    const [elevator, setelevator] = useState(false);
    const [escalator, setescalator] = useState(true);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    useEffect(() => {
        if (elevator && escalator) {
            g.setPointType({ ...g.PointType, elevator: false, escalator: false, stair: true, });
        } else if (elevator) {
            g.setPointType({ ...g.PointType, elevator: false, escalator: true, stair: true, });
        } else if (escalator) {
            g.setPointType({ ...g.PointType, elevator: true, escalator: false, stair: true, });
        } else {
            g.setPointType({ ...g.PointType, elevator: false, escalator: false, stair: false, });
        }
    }, [elevator, escalator]);
    useEffect(() => {
        if (g.EndSearchInput?.point && g.StartSearchInput?.point) {
            if (g.EndSearchInput?.point.LocationName.text !== g.StartSearchInput?.point.LocationName.text) {
                let { x, y, z } = g.StartSearchInput?.point
                if (g.mallType) {
                    const params = { v: searchParams.get("v"), m: g.mallType, from: `${g.EndSearchInput?.point.x},${g.EndSearchInput?.point.y},${g.EndSearchInput?.point.z}`, to: `${x},${y},${z}`, elevator: elevator, escalator: escalator };
                    navigate({
                        pathname: '/',
                        search: `?${createSearchParams(params,)}`,
                    });
                }
            }
        }

    }, [g.StartSearchInput?.point, g.EndSearchInput?.point, elevator, escalator])
    return (
        <>
            {g.DisplayStartPointResult && <div className='DisplayStartPointResult'>
                {g.DisplayStartPointResult.map((d, i) => {
                    return <p key={i} onClick={() => {
                        g.setStartSearchInput({ name: d.LocationName.text, point: d })
                        g.setDisplayStartPointResult(null)
                    }}> {d.LocationName.text}</p>

                })}
            </div>
            }
            {g.DisplayEndPointResult && <div className='DisplayEndPointResult'>
                {g.DisplayEndPointResult.map((d, i) => {
                    return <p key={i} onClick={() => {
                        g.setEndSearchInput({ name: d.LocationName.text, point: d })
                        g.setDisplayEndPointResult(null)
                    }}> {d.LocationName.text}</p>

                })}
            </div>
            }
            {/* <span className='searcharrow1' onClick={() => {
                g.setStartAndEndPart(false)
                g.setEndSearchInput(null)
                g.setStartSearchInput(null)
                g.setStapeByStape(null)
                g.setpath([])
            }}>&#8592;</span> */}
            <div className="startEnd">
                <div className='flex items-center justify-around '>
                    <div>
                        <span className='flex border-b-2 py-1 '>
                            <p className='w-24 py-1 font-semibold'>Start Point :</p>
                            <input type="text"
                                value={g.StartSearchInput ? g.StartSearchInput.name : ""}
                                onChange={(e) => FilterValue(e, g, "start")} onFocus={(e) => FilterValue(e, g, "start")}
                            />
                        </span>
                        <span className='flex py-1'>
                            <p className='w-24 py-1 font-semibold'>End Point :</p>
                            <input type="text" value={g.EndSearchInput ? g.EndSearchInput.name : ""}
                                onChange={(e) => FilterValue(e, g, "endpage")} onFocus={(e) => FilterValue(e, g, "endpage")} />
                        </span>
                    </div>
                    <span onClick={() => {
                        let startpoint = { ...g.StartSearchInput }
                        let endpoint = { ...g.EndSearchInput }
                        g.setStartSearchInput({ ...endpoint })
                        g.setEndSearchInput({ ...startpoint })
                    }}>
                        <img src="/icon/Direction.png" alt="" className='w-6' />
                    </span>

                </div>
                <div className="flex justify-around items-center">
                    <span>
                        <label className="container">
                            Elevator
                            <input type="checkbox" checked={elevator} onChange={() => setelevator(!elevator)} />
                            <span className="checkmark"></span>
                        </label>
                    </span>
                    <span>
                        <label className="container">
                            Escalator
                            <input type="checkbox" checked={escalator} onChange={() => setescalator(!escalator)} />
                            <span className="checkmark"></span>
                        </label>
                    </span>

                </div>
            </div>
        </>
    )
}

export default StartAndEndSearch